export const getDevice = () => {
  // Check if the device is mobile or desktop
  const userAgent = navigator.userAgent.toLowerCase();

  const isMobile = /iphone|ipad|ipod|android|blackberry|windows phone/g.test(
    userAgent
  );
  const isTablet = /(ipad|tablet|playbook|silk)|(android(?!.*mobile))/g.test(
    userAgent
  );
  const isNativeApp =
    typeof window !== "undefined" && "ReactNativeWebView" in window;

  const device = isTablet || isMobile || isNativeApp ? "mobile" : "desktop";
  return device;
};
